export { default } from './dist/vue-github-corners.common'
export * from './dist/vue-github-corners.common'
import './dist/vue-github-corners.css'
